<template>
    <v-card class="main-container">
        <v-card-text>
            <v-tabs v-model="activeTab">
                <v-tab
                exact-active-class="custom-color"
                v-for="(item, i) in statusList"
                :key="item.status_id"
                :style="{color: $mainColor + ' !important', caretColor: $mainColor + ' !important'}">
                    {{item.name}}
                </v-tab>
                <v-tabs-items>
                    <v-list class="d-flex align-center justify-start">
                        <v-list-item>
                            <v-btn
                            class="my-2"
                            x-small
                            :color="$mainColor"
                            style="color: white; margin-right: 15px;"
                            @click="checkAllProposal">Выбрать все</v-btn>
                            <template>
                                <v-btn
                                @click="$emit('redirect-document', statusList[activeTab].currentProposal)"
                                :disabled="statusList[activeTab].currentProposal.length === 0"
                                x-small>
                                <v-badge
                                x-small
                                    color="#15336d"
                                    :content="statusList[activeTab].currentProposal.length">
                                    {{$t('ModeratorList.upload_to_pdf')}}
                                </v-badge>
                            </v-btn>
                            </template>
                            <template v-if="(statusList[activeTab].status_id === statuses.Scheduled) && can_upload_to_excel">
                                <v-btn
                                    @click="$emit('upload-to-excel', [statusList[activeTab].currentProposal, statusList[activeTab].status_id])"
                                    :disabled="statusList[activeTab].currentProposal.length === 0"
                                    x-small style="margin-left: 15px;">
                                <v-badge x-small color="#15336d"
                                    :content="statusList[activeTab].currentProposal.length">
                                    {{$t('ModeratorList.upload_to_excel')}}
                                </v-badge>
                            </v-btn>
                            </template>
                        </v-list-item>
                    </v-list>
                    <v-data-table
                        v-model="statusList[activeTab].currentProposal"
                        show-select
                        :style="{color: $mainColor}"
                        :headers="current_headers"
                        :items="listProposals"
                        :loading="preloaderYet"
                        :loading-text="$t('User.loading_orders')"
                        :items-per-page="20"
                        :footer-props="{
                            itemsPerPageOptions: [10, 20, 50],
                            itemsPerPageText: 'кол-во на стр.:',
                        }"
                    >
                        <template v-slot:item.id="{ item }">
                            <span @click="$emit('open-modal-card', item)" style="cursor: pointer;">
                                {{ item.id }}
                            </span>
                        </template>
                        <template v-slot:item.name="{ item }">
                            <v-tooltip v-if="item.last_status_id == statuses.Modification" right>
                                <span>{{$t('need_modification')}}</span>
                            </v-tooltip>
                            <span @click="$emit('open-modal-card', item)" style="cursor: pointer;">
                                {{ item.name ? item.name: $t('untitled') }}
                            </span>
                        </template>
                        <template v-slot:item.author="{ item }">
                            <span>
                            {{ item.author }}
                            </span>
                        </template>
                        <template v-slot:item.organisation="{ item }">
                            <span>
                            {{ item.organisation }}
                            </span>
                        </template>
                        <template v-slot:item.date_income="{ item }" >
                            {{g.toDate(item.date_income)}}
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                    small
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="$emit('open-pdf', item.id)">
                                    mdi-file
                                    </v-icon>
                                </template>
                                <span>{{$t('User.open_pdf')}}</span>
                            </v-tooltip>
                            <v-icon
                                v-if="item.last_status_id === statuses.Created || item.last_status_id === statuses.Draft"
                                class="ma-2"
                                small
                                color="red lighten-1"
                                @click="dialogConfirmDelete = true; delete_id = item.id">
                                mdi-delete
                            </v-icon>
                        </template>


                    </v-data-table>
                </v-tabs-items>
            </v-tabs>

        </v-card-text>

        <v-dialog v-model="dialogConfirmDelete" persistent max-width="520px">
            <v-card>
                <v-card-title class="headline">{{$t('Actions.confirmation')}}</v-card-title>
                <v-card-text>Вы действительно хотите удалить заявку # {{ delete_id }}</v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" outlined :color="$mainColor" @click="dialogConfirmDelete = false">{{$t('cancel')}}</v-btn>
                <v-btn color="green darken-1" outlined :color="$mainColor" @click="dialogConfirmDelete = false, deleteProposal()">удалить</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import {ProposalStatus} from '../../store/proposalStatus.js'

export default {
    name: 'ModeratorTab2Layouts',
    props: {
        listProposals: [Array, Object],
        preloaderYet: Boolean,
    },
    data() {
        return {
            delete_id: null,
            dialogConfirmDelete: false,
            statuses: null,
            currentProposal: [],
            listRequestFormat: [],
            activeTab: 0,
            checkedItemTable: false,
            statusList: [
                { status_id: 105, slug:'draft', name: this.$t('ModeratorList.applications_still_being_formed'), checkedItemTable: false, count: 0, currentProposal: []},
                { status_id: 2, slug:'created', name: this.$t('ModeratorList.incoming_requests'), checkedItemTable: false, count: 0, currentProposal: []},
                { status_id: 104, slug:'expertise', name: this.$t('ModeratorList.on_examination'), checkedItemTable: false, count: 0, currentProposal: []},
                // { status_id: 4, slug:'statement', name: this.$t('ModeratorList.expert_advice'), checkedItemTable: false, count: 0, currentProposal: []},
                // { status_id: 5, slug:'approve', name: this.$t('ModeratorList.adopted'), checkedItemTable: false, count: 0, currentProposal: []},
                // { status_id: 6, slug:'modification', name: this.$t('ModeratorList.on_completion'), checkedItemTable: false, count: 0, currentProposal: []},
                { status_id: 7, slug:'scheduled', name: this.$t('ModeratorList.experiment_planned'), checkedItemTable: false, count: 0, currentProposal: []},
                { status_id: 8, slug:'need_report', name: this.$t('ModeratorList.awaiting_report'), checkedItemTable: false, count: 0, currentProposal: []},
                { status_id: 9, slug:'done', name: this.$t('ModeratorList.completed'), checkedItemTable: false, count: 0, currentProposal: []},
                { status_id: 10, slug:'publication', name: this.$t('ModeratorList.there_publication'), checkedItemTable: false, count: 0, currentProposal: []},
                { status_id: 12, slug:'deleted', name: this.$t('ModeratorList.deleted'), checkedItemTable: false, count: 0, currentProposal: []},
                { status_id: 11, slug:'reject', name: this.$t('ModeratorList.rejected'), checkedItemTable: false, count: 0, currentProposal: []},
                { status_id: 14, slug:'not_realized', name: this.$t('ModeratorList.not_realized'), checkedItemTable: false, count: 0, currentProposal: []},
                { status_id: 13, slug:'archived', name: this.$t('ModeratorList.archived'), checkedItemTable: false, count: 0, currentProposal: []},
            ],
            current_headers: [],
            headers_base: [
                { text: 'ID', align: 'start', sortable: true, value: 'id'},
                { text: this.$t('name'), sortable: false, value: 'name'},
                { text: 'Станция', align: 'start', sortable: true, value: 'station_name'},
                { text: 'Заявитель', align: 'start', sortable: true, value: 'author'},
                { text: this.$t('ModeratorTabLayouts.organization'), align: 'start', sortable: true, value: 'organisation'},
                { text: this.$t('date_created'), align: 'start', sortable: true, value: 'date_income'},
                { text: this.$t('actions'), value: 'actions', sortable: false}
            ],
            headers_exper: [
                { text: 'ID', align: 'start', sortable: true, value: 'id'},
                { text: this.$t('name'), sortable: false, value: 'name'},
                { text: 'Станция', align: 'start', sortable: true, value: 'station_name'},
                { text: 'Эксперт', align: 'start', sortable: true, value: 'expert'},
                { text: 'Заявитель', align: 'start', sortable: true, value: 'author'},
                { text: this.$t('ModeratorTabLayouts.organization'), align: 'start', sortable: true, value: 'organisation'},
                { text: this.$t('date_created'), align: 'start', sortable: true, value: 'date_income'},
                { text: this.$t('actions'), value: 'actions', sortable: false}
            ],
            newListProposals: [],
            can_upload_to_excel: true,
        }
    },
    beforeMount() {
        this.statuses = ProposalStatus

        this.listRequestFormat = this.listProposals
        this.current_headers = this.headers_base
    },
    computed: {
        ...mapGetters(['GETTERS_LOGIN']),
    },
    methods: {
        ...mapActions(['DELETE_REQUEST']),
        ...mapMutations([
            'UPDATE_OVERLAY',
        ]),
        deleteProposal(id) {
            this.UPDATE_OVERLAY(true)

            try {
                this.DELETE_REQUEST({
                id: this.GETTERS_LOGIN,
                deleteId: this.delete_id
                })
                .then(() => {
                    this.UPDATE_OVERLAY(false)
                    this.listProposals = this.listProposals.filter(item => item.id !== this.delete_id)
                    this.$messageHelper(`${this.$t('applications')} № ${this.delete_id} ${this.$t('cancel')}`, 'success', 3000)
                })
            } catch (e) {
                this.UPDATE_OVERLAY(false)
                this.$messageHelper(`${this.$t('error_occurred')}: ${e}`, 'error', 3000)
            }


        },
        checkAllProposal() {

            if (!this.statusList[this.activeTab].checkedItemTable) {

                this.listRequestFormat.forEach(item => {
                    this.statusList[this.activeTab].currentProposal.push(item)
                    this.statusList[this.activeTab].count += 1
                })

                this.statusList[this.activeTab].checkedItemTable = true

            } else {

                this.statusList[this.activeTab].count = 0
                this.statusList[this.activeTab].checkedItemTable = false
            }

        }
    },
    watch: {
        activeTab(val) {
            // console.log('activeTab', val)
            this.listRequestFormat = this.listProposals;
            this.$emit('load-new-request', [val, false])
            if(val == 3 || val == 2)
                this.current_headers = this.headers_exper
            else
                this.current_headers = this.headers_base
        },
        listProposals(val) {
           this.listRequestFormat = this.listProposals;
        }
   }
}
</script>
<style scoped>
.headline{
    font-size: 12px;
  }
.btn-load-more{
    color: rgb(22, 51, 110);
    border-radius: 0px;
    box-shadow: none;
    margin-bottom: -26px;
    width: 100%;
    z-index: 1;
}
.v-card{
  margin-bottom: 30px;
    border: 0px;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
    letter-spacing: 0.5px;
    border-radius: 13px;
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,0.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,0.05);
}
.new-proposal{
  background-color: rgba(22, 51, 110,0.2);
  border-radius: 0px 8px 8px 0px;
  margin-left: 0px !important;
  margin-bottom: 0px !important;
  margin-top: 14px !important;

}
.new-proposal:hover{
  -webkit-transform: translateY(-2px);
  transform: translateY(-2px);
}

</style>
<style>
.v-application .v-tabs-slider-wrapper {
    color: #15336d !important;
}
</style>
